import React from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { OpenInNew } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import logo from '../../images/logo.png';
import pypi from '../../images/pypi.png';
import './home.css';

const useStyles = makeStyles({
    media: {
        height: '18em',
    },
    grid: {
        height: "100%"
    }
});

const translate = (key: string) => {
    if (key === 'home.platform.prompt-storage') {
        return 'Large Language Model (LLM) Prompt Storage in the Cloud';
    }
    if (key === 'home.platform.prompt-storage-details') {
        return 'Configure and store system and use cases specific prompts for ease of use and storage in the cloud.';
    }
    if (key === 'home.signup') {
        return 'Register';
    }
    if (key === 'home.contact') {
        return 'Contact';
    }
    if (key === 'home.login') {
        return 'Login';
    }
    if (key === 'home.platform.intro') {
        return 'Give yourself and your team a headstart with llm prompt storage in the cloud.';
    }
    if (key === 'home.platform.intro2') {
        return 'Reduce boilerplate code with a library of named entity recognition models for your domain.';
    }
    if (key === 'home.platform.intro3') {
        return 'pip install searchagent';
    }
    if (key === 'home.consulting.intro1') {
        return 'We work with transformers, datasets, LLMs to build your products.';
    }
    if (key === 'home.consulting.intro2') {
        return 'We train and build models for named entity recognition, text summarization, question/answering and more.';
    }
    if (key === 'home.consulting.intro3') {
        return '';
    }
    if (key === 'home.consulting.intro4') {
        return 'Use the Contact button to reach us for machine learning consulting.';
    }
    if (key === 'home.platform') {
        return 'Platform';
    }
    if (key === 'home.welcme.intro6') {
        return 'Platform features';
    }
    if (key === 'home.consulting') {
        return 'Consulting';
    }
    if (key == 'home.product') {
        return 'product';
    }
    if (key == 'home.fullstack') {
        return 'fullstack';
    }
    if (key == 'home.card1') {
        return 'dataengineering';
    }
    if (key == 'home.set') {
        return 'set';
    }
    if (key == 'home.privacy') {
        return 'Privacy Policy';
    }
    if (key == 'home.terms') {
        return 'Terms of Use';
    }
    if (key == 'home.copyright') {
        return '© searchagent.co 2024. All rights reserved. ';
    }
    return key;
};

const Home = () => {
    const classes = useStyles();
    return (
        <Container>
            <div className="home">
                <Button href="/contact">
                    {translate('home.contact')}
                </Button>
                <Button href="/signup">
                    {translate('home.signup')}
                </Button>
                <Button href="/login">
                    {translate('home.login')}
                </Button>
            </div>
            <Grid
                container
                spacing={1}
                direction="row"
                justify="center"
                alignItems="center"
            >
                <Grid direction='row' xs={12} style={{ textAlign: "center" }}>
                    <Card elevation={0}>
                        <CardContent>
                            <div>
                                <a href={'/'} tabIndex={-1} rel="noreferrer" target="_blank">
                                    <img aria-hidden="true" src={logo} />
                                </a>
                            </div>
                            <div>
                                <Typography variant="h2" component="h3">
                                    {translate('home.platform')}
                                </Typography>
                            </div>
                            <Typography variant="h5" component="h3">
                                {translate('home.platform.intro')}
                            </Typography>
                            <Typography variant="h5" component="h3">
                                {translate('home.platform.intro2')}
                            </Typography>
                            <Typography variant="h4" component="h3">
                                <br></br>
                                {translate('home.platform.intro3')}
                            </Typography> 
                            <img aria-hidden="true" src={pypi} />
                            <Typography variant="h2" component="h3">
                                <br></br>
                                {translate('home.consulting')}
                            </Typography>
                            <Typography variant="h5" component="h5">
                                {translate('home.consulting.intro1')}
                            </Typography>
                            <Typography variant="h5" component="h5">
                                {translate('home.consulting.intro2')}
                            </Typography>
                            <Typography variant="h5" component="h5">
                                {translate('home.consulting.intro3')}
                            </Typography>
                            <Typography variant="h5" component="h5">
                                {translate('home.consulting.intro4')}
                            </Typography>
                        </CardContent>
                    </Card>
                    <Card elevation={0}>
                        <CardContent>
                            <Paper elevation={0}>
                                <Typography>{translate('home.copyright')}</Typography>
                            </Paper>
                            <Button href="/terms-of-use.html">
                                <OpenInNew style={{ paddingRight: '0.5em' }} />
                                {translate('home.terms')}
                            </Button>
                            <Button href="/privacy-policy.html">
                                <OpenInNew style={{ paddingRight: '0.5em' }} />
                                {translate('home.privacy')}
                            </Button>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Container>
    );
};

export default Home;
